var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
/* eslint-disable max-lines */
import { DrawerBody } from '@one-thd/sui-atomic-components';
import { useThdCustomer } from '@thd-olt-functional/customer-information';
import { DateTime } from 'luxon';
import React, { useEffect, useState, } from 'react';
import { getQuantityByStatus } from '../../../utils/order-details/LineItemUtils';
import { SubmitDeliveryAddressGetCitiesByZipCode } from '../../../api/oms/edit-delivery-address';
import { FeatureSwitches } from '../../../constants/feature-switches';
import { FLOW_TYPES } from '../../../constants/out-of-stock';
import { FULFILLMENT_TYPE } from '../../../constants/status';
import { OmmAvailableDeliverySlots, OmmAvailableFulfillmentOptions, } from '../../../hooks/delivery-hooks';
import { useExperienceContext, useOrderContext, useFulfillmentGroupContext, } from '../../../hooks/useContexts';
import { EditDeliveryAddressErrorMessages, } from '../../../models/edit-delivery-address';
import '../../../styles/drawer.scss';
import { getAddresses, submitEditDeliveryAddress, validateDeliveryAddress, } from '../../../utils/edit-delivery-address/editDeliveryAddressUtils';
import { getWindow } from '../../../utils/general';
import { areAddressesEqual, extractAddressFromFulfillmentGroup, } from '../../../utils/order-details/OrderDetailsUtils';
import { convertedFulfillmentTypes } from '../OrderTrackingDetails';
import { getFlowTypeValue } from '../util/OutOfStock';
import { EditDeliveryAddressChangeFormBody } from './EditDeliveryAddressChangeFormBody';
import { EditDeliveryAddressChangeFormFooter } from './EditDeliveryAddressChangeFormFooter';
import { EditDeliveryAddressChooseAddress } from './EditDeliveryAddressChooseAddress';
import { isBopisOutOfStockRecoverable } from '../util/FulfillmentStatus';
export var EditDeliveryAddressChangeForm = function (_a) {
    var _b, _c, _d;
    var firstNameValue = _a.firstNameValue, lastNameValue = _a.lastNameValue, phoneNumberValue = _a.phoneNumberValue, streetAddressValue = _a.streetAddressValue, addressLineTwoValue = _a.addressLineTwoValue, zipCodeValue = _a.zipCodeValue, cityStateValue = _a.cityStateValue, enteredEditFlow = _a.enteredEditFlow, closeDrawer = _a.closeDrawer, setFirstName = _a.setFirstName, setLastName = _a.setLastName, setPhoneNumber = _a.setPhoneNumber, setStreetAddress = _a.setStreetAddress, setAddressLineTwo = _a.setAddressLineTwo, setZipCode = _a.setZipCode, setCityState = _a.setCityState, setIsChangeForm = _a.setIsChangeForm, setEnteredEditFlow = _a.setEnteredEditFlow, setShowDrawerError = _a.setShowDrawerError, setIsDeliveryDetails = _a.setIsDeliveryDetails, setUpdatedAddressData = _a.setUpdatedAddressData, setNewDeliveryAddressDetails = _a.setNewDeliveryAddressDetails, setEditDeliveryAddressAlert = _a.setEditDeliveryAddressAlert, previousCountry = _a.previousCountry, setIsAddressList = _a.setIsAddressList, isAddressList = _a.isAddressList, isDefaultValue = _a.isDefaultValue, setIsDefault = _a.setIsDefault, isLoading = _a.isLoading, setIsLoading = _a.setIsLoading, isExcludedAddress = _a.isExcludedAddress, setIsExcludedAddress = _a.setIsExcludedAddress, isValidated = _a.isValidated, setIsValidated = _a.setIsValidated, deliveryAddressCreateCartRequestData = _a.deliveryAddressCreateCartRequestData, submitCreateForm = _a.submitCreateForm, setSubmitCreateForm = _a.setSubmitCreateForm, setIsAddNewAddressFlow = _a.setIsAddNewAddressFlow, validationEt = _a.validationEt, setValidationEt = _a.setValidationEt, setIsDeliveryOptions = _a.setIsDeliveryOptions;
    var _e = useFulfillmentGroupContext(), fulfillmentGroup = _e.fulfillmentGroup, fulfillmentGroupIndex = _e.fulfillmentGroupIndex;
    var isConsumerApp = useExperienceContext().isConsumerApp;
    var _f = useOrderContext(), setAvailableDeliverySlots = _f.setAvailableDeliverySlots, setSelectedDateId = _f.setSelectedDateId, setAvailableDeliverySlotsResponse = _f.setAvailableDeliverySlotsResponse, orderDetailsData = _f.orderDetailsData, setSelectedAddressId = _f.setSelectedAddressId;
    var _g = useOrderContext(), currentDrawer = _g.currentDrawer, isEligibilityChecked = _g.isEligibilityChecked, isEligible = _g.isEligible, setDeliveryAddresses = _g.setDeliveryAddresses, setDeliveryAddressesApiError = _g.setDeliveryAddressesApiError, setDeliveryAvailableSlotsApiError = _g.setDeliveryAvailableSlotsApiError, setIsEligible = _g.setIsEligible, setIsEligibilityChecked = _g.setIsEligibilityChecked;
    var _h = useState(false), invalidField = _h[0], setInvalidField = _h[1];
    var _j = useState(previousCountry), country = _j[0], setCountry = _j[1];
    var _k = useState(false), isPOBoxAddressLine1 = _k[0], setIsPOBoxAddressLine1 = _k[1];
    var _l = useState(false), isPOBoxAddressLine2 = _l[0], setIsPOBoxAddressLine2 = _l[1];
    var _m = useState(false), isZipCodeChanged = _m[0], setIsZipCodeChanged = _m[1];
    var _o = useState([]), getCitiesByZipCode = _o[0], setGetCitiesByZipCode = _o[1];
    var isIos = (_b = getWindow()) === null || _b === void 0 ? void 0 : _b.navigator.userAgent.includes('Mac');
    var isIosMobile = isIos && isConsumerApp;
    var traceId = orderDetailsData.traceId;
    var flowType = getFlowTypeValue(currentDrawer, FLOW_TYPES.EDIT_DELIVERY_ADDRESS);
    var _p = useState(false), isSameAddress = _p[0], setIsSameAddress = _p[1];
    var _q = useThdCustomer() || {}, isLoggedIn = _q.isLoggedIn, isExchangeCustomer = _q.isExchangeCustomer;
    var _r = useState([]), localCities = _r[0], setLocalCities = _r[1];
    var isAuthTHDUser = Boolean(isLoggedIn && !isExchangeCustomer);
    var isAddingNewAddress = Boolean(FeatureSwitches.enableEditDeliveryAddressAppify) && !isAddressList;
    var fulfillmentTypeCode = ((_c = convertedFulfillmentTypes(fulfillmentGroup === null || fulfillmentGroup === void 0 ? void 0 : fulfillmentGroup.fulfillmentType)) === null || _c === void 0 ? void 0 : _c.toUpperCase()) || undefined;
    var isBopisOutOfStock = isBopisOutOfStockRecoverable(fulfillmentGroup);
    var isBopisOutOfStockFfaLiteCall = Boolean(FeatureSwitches.enableBopisOutOfStockFfaLiteCall);
    // Separate loading states because eligibility and getAddresses are not chained.
    // isSkeletonLoading combines both to control the UI skeleton.
    var _s = useState(false), isEligibilityLoading = _s[0], setIsEligibilityLoading = _s[1];
    var _t = useState(false), isGetAddressesLoading = _t[0], setIsGetAddressesLoading = _t[1];
    var isSkeletonLoading = isGetAddressesLoading || isEligibilityLoading;
    // When switching back to the address list view, clear selection so the first tile is auto-selected
    useEffect(function () {
        if (isAddressList) {
            setSelectedAddressId('');
        }
    }, [isAddressList]);
    var handleZipCodeStatus = function () {
        if ((invalidField && zipCodeValue.length !== 5) || isExcludedAddress) {
            return 'error';
        }
        if (!isValidated) {
            return 'warning';
        }
        if (isSameAddress) {
            return 'error';
        }
        if (isEligibilityChecked && !isEligible) {
            return 'error';
        }
        return undefined;
    };
    var _u = extractAddressFromFulfillmentGroup(fulfillmentGroup.shippingAndHandling ||
        fulfillmentGroup.storePickup ||
        fulfillmentGroup.bodfsDeliveryAndHandling, fulfillmentGroup.fulfillmentType), firstName = _u.firstName, lastName = _u.lastName, addressLine1 = _u.addressLine1, addressLine2 = _u.addressLine2, zipCode = _u.zipCode, city = _u.city, state = _u.state, phoneNumber = _u.phoneNumber;
    useEffect(function () {
        if (!submitCreateForm)
            return;
        // Render Delivery Options when FS is true, not for BOPIS OOS
        if (FeatureSwitches.isSFBLEnabled && !currentDrawer) {
            setIsChangeForm(false);
            setIsDeliveryOptions(true);
        }
        else {
            // Address has been validated
            if (fulfillmentGroup.fulfillmentType === FULFILLMENT_TYPE.BODFS) {
                getAvailableSlots();
            }
            else {
                submitEditDeliveryAddress({
                    deliveryAddress: deliveryAddress,
                    firstNameValue: firstNameValue,
                    lastNameValue: lastNameValue,
                    phoneNumberValue: phoneNumberValue,
                    isDefaultValue: isDefaultValue,
                    orderDetailsData: orderDetailsData,
                    fulfillmentTypeCode: fulfillmentTypeCode,
                    deliveryAddressCreateCartRequestData: deliveryAddressCreateCartRequestData,
                    isAddingNewAddress: isAddingNewAddress,
                    fulfillmentGroupIndex: fulfillmentGroupIndex,
                    fulfillmentGroup: fulfillmentGroup,
                    traceId: traceId,
                    setIsChangeForm: setIsChangeForm,
                    setIsDeliveryDetails: setIsDeliveryDetails,
                    setIsLoading: setIsLoading,
                    setShowDrawerError: setShowDrawerError,
                    setIsExcludedAddress: setIsExcludedAddress,
                    setIsValidated: setIsValidated,
                    closeDrawer: closeDrawer,
                    setUpdatedAddressData: setUpdatedAddressData,
                    setEditDeliveryAddressAlert: setEditDeliveryAddressAlert,
                    flowType: flowType,
                });
            }
            // reset submitCreateForm to false
            setSubmitCreateForm(false);
        }
    }, [submitCreateForm]);
    useEffect(function () {
        var _a, _b;
        if (getCitiesByZipCode.length > 0 && isZipCodeChanged) {
            setCityState("".concat((_a = getCitiesByZipCode[0]) === null || _a === void 0 ? void 0 : _a.city, ", ").concat((_b = getCitiesByZipCode[0]) === null || _b === void 0 ? void 0 : _b.stateCode));
            setIsZipCodeChanged(false);
        }
    }, [getCitiesByZipCode]);
    useEffect(function () {
        setIsExcludedAddress(false);
    }, [streetAddressValue, zipCodeValue, addressLineTwoValue]);
    var deliveryAddress = {
        addressLine1: streetAddressValue || '',
        addressLine2: addressLineTwoValue || null,
        city: cityStateValue.split(',')[0],
        state: (_d = cityStateValue === null || cityStateValue === void 0 ? void 0 : cityStateValue.split(',')[1]) === null || _d === void 0 ? void 0 : _d.trim(),
        zipCode: zipCodeValue,
        country: country,
    };
    var getAvailableSlots = function () {
        var _a, _b;
        var availableSlotsRequest = {
            flowType: FLOW_TYPES.EDIT_DELIVERY_ADDRESS,
            orderId: orderDetailsData === null || orderDetailsData === void 0 ? void 0 : orderDetailsData.orderNumber,
            emailId: orderDetailsData === null || orderDetailsData === void 0 ? void 0 : orderDetailsData.emailId,
            fulfillmentType: ((_a = convertedFulfillmentTypes(fulfillmentGroup === null || fulfillmentGroup === void 0 ? void 0 : fulfillmentGroup.fulfillmentType)) === null || _a === void 0 ? void 0 : _a.toUpperCase()) || '',
            deliverySlotTypes: ['All Day'],
            et: fulfillmentGroup === null || fulfillmentGroup === void 0 ? void 0 : fulfillmentGroup.et,
            net: orderDetailsData === null || orderDetailsData === void 0 ? void 0 : orderDetailsData.net,
            lineItems: ((_b = fulfillmentGroup === null || fulfillmentGroup === void 0 ? void 0 : fulfillmentGroup.lineItems) === null || _b === void 0 ? void 0 : _b.map(function (type) { return ({
                lineId: type.lineId,
                omsId: "".concat(type.secOmsId),
                sku: "".concat(type.skuNumber),
                price: type.unitPrice,
                quantity: type.currentQuantity,
            }); })) || [],
            fulfillmentAddress: deliveryAddress,
        };
        OmmAvailableDeliverySlots(availableSlotsRequest, isAuthTHDUser, orderDetailsData === null || orderDetailsData === void 0 ? void 0 : orderDetailsData.xAuthGuestToken, orderDetailsData === null || orderDetailsData === void 0 ? void 0 : orderDetailsData.traceId)
            .then(function (response) {
            var _a, _b;
            var data = response.data.data;
            setAvailableDeliverySlotsResponse(data);
            var sortedSlots = __spreadArray([], ((_a = data === null || data === void 0 ? void 0 : data.availableDeliverySlots) !== null && _a !== void 0 ? _a : []), true).sort(function (slotA, slotB) {
                return DateTime.fromISO(slotA.startDateTime).toMillis() -
                    DateTime.fromISO(slotB.startDateTime).toMillis();
            });
            setSelectedDateId(((_b = sortedSlots === null || sortedSlots === void 0 ? void 0 : sortedSlots[0]) === null || _b === void 0 ? void 0 : _b.id) || '');
            setAvailableDeliverySlots(sortedSlots);
            setIsChangeForm(false);
            setIsDeliveryDetails(true);
            setDeliveryAvailableSlotsApiError(function (prev) {
                var _a;
                return (__assign(__assign({}, prev), (_a = {}, _a["".concat(fulfillmentGroupIndex)] = false, _a)));
            });
        })
            .catch(function () {
            setDeliveryAvailableSlotsApiError(function (prev) {
                var _a;
                return (__assign(__assign({}, prev), (_a = {}, _a["".concat(fulfillmentGroupIndex)] = true, _a)));
            });
            closeDrawer();
        })
            .finally(function () {
            setIsLoading(false);
        });
    };
    var handleClearAll = function () {
        setFirstName('');
        setLastName('');
        setStreetAddress('');
        setAddressLineTwo(null);
        setZipCode('');
        setCityState('');
        setCountry(previousCountry);
        setIsSameAddress(false);
        setIsDefault(false);
    };
    var checkSameAddress = function () {
        return areAddressesEqual({
            firstName: firstName,
            lastName: lastName,
            phoneNumber: phoneNumber,
            city: city,
            state: state,
            addressLine1: addressLine1,
            addressLine2: addressLine2,
            zipCode: zipCode,
            country: country,
        }, __assign({ firstName: firstNameValue, lastName: lastNameValue, phoneNumber: phoneNumberValue }, deliveryAddress));
    };
    var handleValidateDeliveryAddress = function () {
        validateDeliveryAddress({
            firstNameValue: firstNameValue,
            lastNameValue: lastNameValue,
            phoneNumberValue: phoneNumberValue,
            streetAddressValue: streetAddressValue,
            addressLineTwoValue: addressLineTwoValue,
            zipCodeValue: zipCodeValue,
            cityStateValue: cityStateValue,
            country: country,
            flowType: flowType,
            fulfillmentTypeCode: fulfillmentTypeCode,
            orderDetailsData: orderDetailsData,
            setInvalidField: setInvalidField,
            setIsSameAddress: setIsSameAddress,
            setIsLoading: setIsLoading,
            setNewDeliveryAddressDetails: setNewDeliveryAddressDetails,
            setShowDrawerError: setShowDrawerError,
            fulfillmentGroupIndex: fulfillmentGroupIndex,
            setIsValidated: setIsValidated,
            closeDrawer: closeDrawer,
            setValidationEt: setValidationEt,
            validationEt: validationEt,
            traceId: traceId,
            deliveryAddress: deliveryAddress,
            checkSameAddress: checkSameAddress,
            isPOBoxAddressLine1: isPOBoxAddressLine1,
            isPOBoxAddressLine2: isPOBoxAddressLine2,
            setSubmitCreateForm: setSubmitCreateForm,
            EditDeliveryAddressErrorMessages: EditDeliveryAddressErrorMessages,
            isValidated: isValidated,
            isAddressList: isAddressList,
        });
    };
    var handleChange = function (event) {
        setCityState(event.target.value);
    };
    var handleZipCodeValueChange = function (zipCodeChange) {
        var _a, _b, _c, _d;
        var request = {
            zipCode: zipCodeChange || zipCode,
            orderId: orderDetailsData === null || orderDetailsData === void 0 ? void 0 : orderDetailsData.orderNumber,
            flowType: flowType,
            fulfillmentType: fulfillmentTypeCode,
        };
        setGetCitiesByZipCode([]);
        var availableFulfillmentOptions = {
            flowType: FLOW_TYPES.BOPIS_OOS_RECOVERY,
            orderId: (orderDetailsData === null || orderDetailsData === void 0 ? void 0 : orderDetailsData.orderNumber) || '',
            emailId: (orderDetailsData === null || orderDetailsData === void 0 ? void 0 : orderDetailsData.emailId) || '',
            originalFulfillmentType: ((_a = convertedFulfillmentTypes(fulfillmentGroup === null || fulfillmentGroup === void 0 ? void 0 : fulfillmentGroup.fulfillmentType)) === null || _a === void 0 ? void 0 : _a.toUpperCase()) || '',
            storeNumber: (_b = orderDetailsData === null || orderDetailsData === void 0 ? void 0 : orderDetailsData.storeNumber) === null || _b === void 0 ? void 0 : _b.toString(),
            lineItems: ((_d = (_c = fulfillmentGroup === null || fulfillmentGroup === void 0 ? void 0 : fulfillmentGroup.lineItems) === null || _c === void 0 ? void 0 : _c.filter(function (type) {
                return type.lineId !== undefined && type.currentQuantity !== undefined;
            })) === null || _d === void 0 ? void 0 : _d.map(function (type) { return ({
                lineId: type.lineId,
                omsId: "".concat(type.secOmsId),
                sku: "".concat(type.skuNumber),
                quantity: getQuantityByStatus(type),
            }); })) || [],
            fulfillmentAddress: {
                zipCode: request.zipCode,
            },
            net: (orderDetailsData === null || orderDetailsData === void 0 ? void 0 : orderDetailsData.net) || '',
        };
        if (isBopisOutOfStockFfaLiteCall && isAddressList && isBopisOutOfStock) {
            setIsEligibilityLoading(true);
            OmmAvailableFulfillmentOptions(availableFulfillmentOptions, isAuthTHDUser, orderDetailsData === null || orderDetailsData === void 0 ? void 0 : orderDetailsData.xAuthGuestToken, orderDetailsData === null || orderDetailsData === void 0 ? void 0 : orderDetailsData.traceId)
                .then(function (fulfillmentOptionsResponse) {
                var data = fulfillmentOptionsResponse.data.data;
                if (
                // For now only check eligibility for STH
                data.availableFulfillmentOptions.delivery.fulfillmentOptions.STH
                    .isEligible === true) {
                    setZipCode(availableFulfillmentOptions.fulfillmentAddress.zipCode);
                    setIsEligible(true);
                }
                else {
                    setIsEligible(false);
                }
                setIsEligibilityChecked(true);
            })
                .catch(function () {
                // TODO: add error handling
            })
                .finally(function () {
                setIsEligibilityLoading(false);
            });
        }
        else {
            SubmitDeliveryAddressGetCitiesByZipCode(request, setGetCitiesByZipCode, setIsChangeForm, setShowDrawerError, fulfillmentGroupIndex, isAuthTHDUser, fulfillmentGroup, orderDetailsData, setIsEligible, setZipCode, setIsEligibilityChecked, setIsEligibilityLoading, availableFulfillmentOptions);
        }
    };
    useEffect(function () {
        if (!currentDrawer && !enteredEditFlow)
            handleZipCodeValueChange();
        setEnteredEditFlow(true);
        if (isAddressList) {
            setIsGetAddressesLoading(true);
            // Reset eligibility check state when opening drawer
            setIsEligibilityChecked(false);
            getAddresses({
                orderDetailsData: orderDetailsData,
                fulfillmentTypeCode: fulfillmentTypeCode,
                isAuthTHDUser: isAuthTHDUser,
                fulfillmentGroup: fulfillmentGroup,
                fulfillmentGroupIndex: fulfillmentGroupIndex,
                setDeliveryAddresses: setDeliveryAddresses,
                setDeliveryAddressesApiError: setDeliveryAddressesApiError,
                closeDrawer: closeDrawer,
            }).then(function () {
                var _a, _b, _c;
                var storeZipCode = (_c = (_b = (_a = fulfillmentGroup.storePickup) === null || _a === void 0 ? void 0 : _a.store) === null || _b === void 0 ? void 0 : _b.address) === null || _c === void 0 ? void 0 : _c.zipCode;
                if ((storeZipCode === null || storeZipCode === void 0 ? void 0 : storeZipCode.length) === 5 &&
                    zipCodeValue &&
                    zipCodeValue !== storeZipCode) {
                    handleZipCodeValueChange(zipCodeValue);
                }
                else if ((storeZipCode === null || storeZipCode === void 0 ? void 0 : storeZipCode.length) === 5) {
                    handleZipCodeValueChange(storeZipCode);
                }
                setIsGetAddressesLoading(false);
            });
        }
    }, []);
    return (React.createElement(React.Fragment, null,
        React.createElement(DrawerBody, null, isAddressList ? (React.createElement(EditDeliveryAddressChooseAddress, { setFirstName: setFirstName, setLastName: setLastName, setPhoneNumber: setPhoneNumber, setStreetAddress: setStreetAddress, setAddressLineTwo: setAddressLineTwo, setZipCode: setZipCode, setCityState: setCityState, setCountry: setCountry, handleClearAll: handleClearAll, setIsAddressList: setIsAddressList, setIsDefault: setIsDefault, isExcludedAddress: isExcludedAddress, isSameAddress: isSameAddress, setIsSameAddress: setIsSameAddress, setIsAddNewAddressFlow: setIsAddNewAddressFlow, setLocalCities: setLocalCities, setIsValidated: setIsValidated, setInvalidField: setInvalidField, zipCodeValue: zipCodeValue, setIsZipCodeChanged: setIsZipCodeChanged, handleZipCodeValueChange: handleZipCodeValueChange, handleZipCodeStatus: handleZipCodeStatus, invalidField: invalidField, isSkeletonLoading: isSkeletonLoading })) : (React.createElement(EditDeliveryAddressChangeFormBody, { getCitiesByZipCode: getCitiesByZipCode, firstNameValue: firstNameValue, lastNameValue: lastNameValue, phoneNumberValue: phoneNumberValue, streetAddressValue: streetAddressValue, addressLineTwoValue: addressLineTwoValue, zipCodeValue: zipCodeValue, cityStateValue: cityStateValue, invalidField: invalidField, isExcludedAddress: isExcludedAddress, isValidated: isValidated, setIsValidated: setIsValidated, isPOBoxAddressLine1: isPOBoxAddressLine1, setIsPOBoxAddressLine1: setIsPOBoxAddressLine1, isPOBoxAddressLine2: isPOBoxAddressLine2, setIsPOBoxAddressLine2: setIsPOBoxAddressLine2, setFirstName: setFirstName, setLastName: setLastName, setStreetAddress: setStreetAddress, setAddressLineTwo: setAddressLineTwo, setZipCode: setZipCode, setIsZipCodeChanged: setIsZipCodeChanged, handleZipCodeValueChange: handleZipCodeValueChange, handleChange: handleChange, isSameAddress: isSameAddress, setIsSameAddress: setIsSameAddress, setCityState: setCityState, handleClearAll: handleClearAll, setLocalCities: setLocalCities, localCities: localCities, handleZipCodeStatus: handleZipCodeStatus }))),
        React.createElement(EditDeliveryAddressChangeFormFooter, { isLoading: isLoading, isValidated: isValidated, isIosMobile: isIosMobile, handleValidateDeliveryAddress: handleValidateDeliveryAddress, closeDrawer: closeDrawer, isAddressList: isAddressList, setIsAddNewAddressFlow: setIsAddNewAddressFlow, isSkeletonLoading: isSkeletonLoading })));
};
